import {
	mdiAccountBoxOutline,
	mdiAccountSupervisor,
	mdiBellOutline,
	mdiCardAccountDetails,
	mdiCash100,
	mdiCityVariantOutline,
	mdiCogs,
	mdiDomain,
	mdiFactory,
	mdiHandshake,
	mdiHandshakeOutline,
	mdiKeyVariant,
	mdiLifebuoy,
	mdiLinkVariant,
	mdiRobotOutline,
	mdiMap,
	mdiEmailMultipleOutline,
	mdiEmailFastOutline,
	mdiHeartPulse,
	mdiMessage,
	mdiSwapHorizontal,
	mdiMessageArrowRight,
	mdiChartTimelineVariantShimmer,
	mdiNetwork,
	mdiNewspaperVariantMultipleOutline,
	mdiPalette,
	mdiTrophy,
	mdiPollBox,
	mdiChartBoxOutline,
	mdiWall,
	mdiSourceBranch,
	mdiClipboardCheckOutline,
	mdiCalendarOutline,
	mdiDeleteOutline,
	mdiChartLine,
	mdiOfficeBuilding,
	mdiInboxArrowDownOutline,
	mdiSortNumericAscending,
	mdiFileSendOutline,
	mdiMapMarkerCheckOutline,
	mdiFlaskOutline,
	mdiPulse,
	mdiPresentation,
} from '@mdi/js'

// Array of sections

export default [
	{
		icon: mdiClipboardCheckOutline,
		title: 'menu.network.overview',
		to: 'network-dashboard',
	},
	{
		icon: mdiCalendarOutline,
		title: 'AdminTasks.myDay',
		to: 'network-my-day',
	},
	{
		icon: mdiMap,
		title: 'menu.network.liveAnalytics',
		to: 'network-live-analytics',
		module: 'MGN,network-systems',
	},
	{
		title: 'menu.blog',
		icon: mdiNewspaperVariantMultipleOutline,
		module: 'MGN,blog',
		children: [
			{
				title: 'Posts',
				to: 'blog-posts-list',
			},
			{
				title: 'categories',
				to: 'blog-categories-list',
			},
			{
				title: 'Tags',
				to: 'blog-tags-list',
			},
		],
	},
	{
		title: 'menu.institutional',
		icon: mdiAccountBoxOutline,
		module: 'MGN,institutional',
		children: [
			{
				title: 'APIS',
				to: 'apis-list',
			},
			{
				title: 'MG Companies',
				to: 'mg-companies-list',
			},
			{
				title: 'menu.companies.companiesType',
				to: 'institutional-companies-type-list',
			},
		],
	},
	{
		icon: mdiKeyVariant,
		title: 'menu.projectsAndKeys.title',
		module: 'MGN,projects-keys',
		children: [
			{
				title: 'menu.projectsAndKeys.list',
				to: 'network-keys-list',
			},
			{
				title: 'menu.projectsAndKeys.projects',
				to: 'network-list-projects',
				roles: ['MGN,admin'],
			},
			{
				title: 'Translatables',
				to: 'network-translatables-list',
				roles: ['MGN,admin'],
			},
		],
	},
	{
		icon: mdiFactory,
		title: 'menu.jobs.industrySectors',
		to: 'industry-sector-categories-list',
	},
	{
		icon: mdiCardAccountDetails,
		title: 'menu.careers.title',
		module: 'MGN,careers',
		children: [
			{
				title: 'menu.careers.applications',
				to: 'network-careers-applications-list',
			},
			{
				title: 'menu.careers.careers',
				to: 'network-careers-list',
			},
			{
				title: 'menu.careers.skills',
				to: 'network-careers-skills-list',
			},
		],
	},
	{
		title: 'menu.companies.companies',
		icon: mdiDomain,
		module: 'MGN,companies',
		children: [
			{
				title: 'menu.companies.companiesList',
				to: 'companies-list',
			},
			{
				title: 'menu.companies.companiesType',
				to: 'companies-type-list',
			},
			{
				title: 'menu.companies.companiesSize',
				to: 'companies-size-list',
			},
			{
				title: 'menu.companies.companiesStage',
				to: 'companies-stage-list',
			},
			{
				title: 'menu.companies.companiesRole',
				to: 'companies-role-list',
			},
			{
				title: 'menu.companies.companyClaims',
				to: 'companies-claims-list',
			},
		],
	},
	{
		icon: mdiHandshake,
		title: 'menu.partners.title',
		module: 'MGN,partners',
		children: [
			{
				title: 'menu.partners.list',
				to: 'network-partners-list',
			},
			{
				title: 'menu.partners.categories',
				to: 'network-partners-categories-list',
			},
		],
	},

	{
		title: 'menu.pressMedia.title',
		icon: mdiNewspaperVariantMultipleOutline,
		module: 'MGN,press-media',
		children: [
			{
				title: 'menu.pressMedia.posts',
				to: 'network-press-posts-list',
			},
			{
				title: 'menu.pressMedia.files',
				to: 'dashboard-analytics',
			},
		],
	},
	{
		icon: mdiCash100,
		title: 'menu.financialSystem.title',
		module: 'MGN,financial',
		children: [
			{
				title: 'menu.financialSystem.payoutsOverview',
				to: 'network-financial-payouts-overview',
			},
			{
				title: 'menu.financialSystem.ledgerOverview',
				to: 'network-finance-overview',
			},
			{
				title: 'menu.financialSystem.ledgerLiabilities',
				to: 'network-finance-liabilities',
			},
			{
				title: 'menu.financialSystem.executionMode',
				to: 'network-finance-execution-mode',
			},
			{
				title: 'menu.financialSystem.payoutFlags',
				to: 'network-finance-payouts',
			},
			{
				title: 'menu.financialSystem.affiliates',
				children: [
					{
						title: 'menu.financialSystem.affiliatesList',
						to: 'network-financial-affiliates-list',
					},
					{
						title: 'menu.financialSystem.affiliatesTransactions',
						to: 'network-financial-affiliates-transactions',
					},
				],
			},
			{
				title: 'menu.financialSystem.banks',
				to: 'network-financial-banks-list',
			},
			{
				title: 'menu.financialSystem.currencies',
				to: 'network-financial-currencies-list',
			},
			{
				title: 'menu.financialSystem.customCarts',
				to: 'network-custom-carts-list',
			},
			{
				title: 'menu.financialSystem.abandonedCarts',
				to: 'network-abandoned-carts-list',
			},
			{
				title: 'menu.financialSystem.cupons',
				to: 'network-financial-cupons-list',
			},
			{
				title: 'menu.financialSystem.expensesCategories',
				to: 'network-financial-expenses-categories-list',
			},
			{
				title: 'menu.financialSystem.invoices',
				children: [
					{
						title: 'menu.financialSystem.invoicesList',
						to: 'network-financial-invoices-list',
					},
					{
						title: 'menu.financialSystem.invoicesCreate',
						to: 'network-financial-invoices-create',
					},
				],
			},
			{
				title: 'menu.financialSystem.failedPayments',
				to: 'network-financial-failed-payments-list',
			},
			{
				title: 'menu.financialSystem.paymentFees',
				to: 'network-financial-payment-fees-list',
			},
			{
				title: 'menu.financialSystem.paymentMethods',
				to: 'network-financial-payment-methods-list',
			},
			{
				title: 'menu.financialSystem.paymentPeriods',
				to: 'network-financial-payment-periods-list',
			},
			{
				title: 'menu.financialSystem.paymentRefunds',
				to: 'network-financial-payment-refunds-list',
			},
			{
				title: 'menu.financialSystem.paymentStatus',
				to: 'network-financial-payment-status-list',
			},
			{
				title: 'menu.financialSystem.paymentTaxes',
				to: 'network-financial-payment-taxes-list',
			},
			{
				title: 'menu.financialSystem.paymentTypes',
				to: 'network-financial-payment-types-list',
			},
			{
				title: 'menu.financialSystem.salePipeline',
				to: 'network-financial-sale-pipelines-list',
			},
			{
				title: 'menu.financialSystem.commissions',
				to: 'commissions-dashboard',
			},
		],
	},
	{
		icon: mdiMap,
		title: 'menu.languagesAndLocations.title',
		module: 'MGN,languages-locations',
		children: [
			{
				title: 'menu.languagesAndLocations.cities',
				to: 'network-cities-list',
			},
			{
				title: 'menu.languagesAndLocations.countries',
				to: 'network-countries-list',
			},
			{
				title: 'menu.languagesAndLocations.languages',
				to: 'network-languages-list',
			},
			{
				title: 'menu.languagesAndLocations.nationalities',
				to: 'network-nationalities-list',
			},
			{
				title: 'menu.languagesAndLocations.regions',
				to: 'network-regions-list',
			},
			{
				title: 'menu.languagesAndLocations.globalRegions',
				to: 'ventures-regions-list',
			},
			{
				title: 'menu.languagesAndLocations.states',
				to: 'network-states-list',
			},
			{
				title: 'menu.languagesAndLocations.timezones',
				to: 'network-timezones-list',
			},
		],
	},

	{
		icon: mdiChartBoxOutline,
		title: 'menu.observatory.title',
		module: 'MGN,observatory-organizations',
		children: [
			{
				icon: mdiChartLine,
				title: 'menu.observatory.intelligence',
				to: 'observatory-intelligence',
			},
			{
				icon: mdiOfficeBuilding,
				title: 'menu.observatory.organizations',
				to: 'observatory-organizations-list',
			},
			{
				icon: mdiInboxArrowDownOutline,
				title: 'menu.observatory.accessRequests',
				to: 'observatory-access-requests-list',
			},
			{
				icon: mdiHandshakeOutline,
				title: 'menu.observatory.professionalIntroductions',
				to: 'observatory-professional-introductions',
			},
			{
				icon: mdiSortNumericAscending,
				title: 'menu.observatory.precedence',
				to: 'observatory-precedence',
			},
			{
				icon: mdiFileSendOutline,
				title: 'menu.observatory.applications',
				to: 'observatory-applications',
			},
			{
				icon: mdiMapMarkerCheckOutline,
				title: 'menu.observatory.entityClaims',
				to: 'observatory-entity-claims',
			},
			{
				icon: mdiFlaskOutline,
				title: 'menu.observatory.experiments',
				to: 'observatory-experiments',
			},
			{
				icon: mdiPulse,
				title: 'menu.observatory.events',
				to: 'observatory-events',
			},
			{
				icon: mdiPresentation,
				title: 'menu.observatory.demo',
				to: 'observatory-demo',
			},
		],
	},

	{
		icon: mdiNetwork,
		title: 'menu.networkSystems.title',
		module: 'MGN,network-systems',
		children: [
			{
				title: 'ACLs',
				roles: ['MGN,admin'],
				children: [
					{
						title: 'menu.networkSystems.ACL.rolesList',
						to: 'mg-platforms-roles',
					},
					{
						title: 'menu.networkSystems.ACL.permissionsList',
						to: 'mg-platforms-permissions',
					},
					{
						title: 'menu.networkSystems.ACL.modulesList',
						to: 'mg-platforms-modules',
					},
					{
						title: 'menu.networkSystems.ACL.companyAccess',
						to: 'network-acl-module-access-company',
					},
					{
						title: 'menu.networkSystems.ACL.userAccess',
						to: 'network-acl-module-access-user',
					},
					{
						title: 'menu.networkSystems.ACL.platformOverview',
						to: 'network-acl-module-access-overview',
					},
				],
			},
			{
				title: 'menu.networkSystems.documents',
				to: 'dashboard-analytics',
			},
			{
				title: 'menu.networkSystems.documentsTypes',
				to: 'network-documents-types-list',
			},
			{
				title: 'menu.networkSystems.documentsWebsites',
				to: 'network-documents-websites-list',
			},
			{
				title: 'menu.networkSystems.domains',
				to: 'network-domains-list',
			},
			{
				// icon: mdiFrequentlyAskedQuestions,
				title: 'menu.editorial.title',
				children: [
					{
						title: 'menu.editorial.calculationRules',
						// to: 'network-faqs-list',
						to: 'network-editorial-calculation-rules-list',
					},
					{
						title: 'menu.editorial.contentTypes',
						to: 'network-editorial-content-types-list',
					},
					{
						title: 'menu.editorial.journalistCategories',
						to: 'network-editorial-journalist-categories-list',
					},
				],
			},
			{
				// icon: mdiFrequentlyAskedQuestions,
				title: 'FAQs',
				children: [
					{
						title: 'menu.networkSystems.FAQs',
						// to: 'network-faqs-list',
						to: 'mg-platforms-faqs',
					},
					{
						title: 'menu.networkSystems.FAQsCategories',
						to: 'network-faqs-categories-list',
					},
				],
			},
			{
				title: 'menu.networkSystems.MGPlatforms',
				to: 'network-network-platforms-list',
			},
			{
				title: 'menu.networkSystems.operationalArea',
				to: 'network-operational-area-list',
			},
			{
				title: 'menu.networkSystems.plans',
				children: [
					{
						title: 'menu.networkSystems.benefits',
						to: 'network-benefits-list',
					},
					{
						title: 'menu.networkSystems.plans',
						to: 'network-plans-list',
					},
					{
						title: 'menu.networkSystems.subscriptions',
						to: 'network-subscriptions-list',
					},
					{
						title: 'menu.networkSystems.cancellations',
						to: 'network-subscriptions-cancellations',
					},
				],
			},
			{
				title: 'menu.networkSystems.pageTags',
				to: 'network-page-tags-list',
			},
			{
				title: 'menu.networkMarketingCampaignsBanners',
				to: 'network-marketing-campaigns-banners-list',
			},
			{
				title: 'menu.networkSystems.products',
				to: 'network-products-list',
			},
			{
				title: 'menu.networkSystems.productBundles',
				to: 'network-product-bundles-list',
			},
			{
				title: 'menu.networkSystems.productTags',
				to: 'network-product-tags-list',
			},
			{
				title: 'menu.networkSystems.pricingRegions',
				to: 'network-pricing-regions-list',
			},
			{
				title: 'menu.networkSystems.roadmap',
				children: [
					{
						title: 'menu.networkSystems.roadmap',
						to: 'network-roadmap-list',
					},
					{
						title: 'menu.networkSystems.roadmapStatus',
						to: 'network-roadmap-status-list',
					},
				],
			},
			{
				title: 'menu.networkSystems.teamMembers',
				to: 'network-members-list',
			},
			{
				title: 'menu.networkSystems.dayTips',
				to: 'network-day-tips-list',
			},
			{
				title: 'menu.networkSystems.announcementBanners',
				to: 'network-announcement-banners-list',
			},
			{
				title: 'menu.networkSystems.whatsNew',
				to: 'network-whats-new-list',
			},
			{
				title: 'menu.networkSystems.announcementBannerPresets',
				to: 'network-announcement-banner-presets-list',
			},
			{
				title: 'menu.networkSystems.promotionBanners',
				to: 'network-promotion-banners-list',
			},
			{
				title: 'menu.networkSystems.appBanners',
				to: 'network-app-banners-list',
			},
			{
				title: 'Themes',
				children: [
					{
						title: 'menu.themes.appThemes',
						to: 'app-themes-list',
					},
					{
						title: 'menu.themes.projectsVariables',
						to: 'projects-variables-list',
					},
				],
			},
			{
				title: 'menu.networkSystems.workflow',
				to: 'network-workflow-status-list',
			},
		],
	},

	// {
	// 	icon: mdiChartTimelineVariantShimmer,
	// 	title: 'menu.reports.title',
	// 	children: [
	// 		{
	// 			title: 'menu.reports.payments',
	// 			to: 'dashboard-analytics',
	// 		},
	// 		{
	// 			title: 'menu.reports.operational',
	// 			to: 'dashboard-analytics',
	// 		},
	// 	],
	// },
	{
		icon: mdiAccountSupervisor,
		title: 'menu.users.title',
		module: 'MGN,users',
		children: [
			{
				title: 'menu.users.list',
				to: 'users-list',
			},
			{
				title: 'menu.users.genders',
				to: 'network-users-genders-list',
			},
			{
				title: 'menu.users.group',
				to: 'network-users-groups-list',
			},
			{
				title: 'menu.users.accountClosures',
				to: 'network-account-closures',
			},
		],
	},
	{
		icon: mdiDeleteOutline,
		title: 'menu.network.deletionRequests',
		to: 'network-deletion-requests',
		module: 'MGN,admin',
	},
	{
		icon: mdiTrophy,
		title: 'Gamification',
		module: 'MGN,gamification',
		children: [
			{
				title: 'Achievements',
				to: 'network-gamification-achievements-list',
			},
		],
	},
	{
		icon: mdiCityVariantOutline,
		title: 'mgCity.menu.group',
		module: 'MGC,city',
		children: [
			{
				title: 'mgCity.menu.districts',
				to: 'network-city-districts-list',
			},
			{
				title: 'mgCity.menu.npcs',
				to: 'network-city-npcs-list',
			},
			{
				title: 'mgCity.menu.features',
				to: 'network-city-features-list',
			},
			{
				title: 'mgCity.menu.missions',
				to: 'network-city-missions-list',
			},
			{
				title: 'mgCity.menu.coinSpawns',
				to: 'network-city-coin-spawns-list',
			},
			{
				title: 'mgCity.menu.easterEggs',
				to: 'network-city-easter-eggs-list',
			},
			{
				title: 'mgCity.menu.seasonalEvents',
				to: 'network-city-seasonal-events-list',
			},
			{
				title: 'mgCity.menu.profiles',
				to: 'network-city-profiles-list',
			},
			{
				title: 'mgCity.menu.dialogues',
				to: 'network-city-dialogues-list',
			},
			{
				title: 'mgCity.menu.texts',
				to: 'network-city-texts-list',
			},
			{
				title: 'mgCity.menu.analytics',
				to: 'network-city-analytics',
			},
			{
				title: 'mgCity.menu.settings',
				to: 'network-city-settings',
			},
		],
	},
	{
		icon: mdiPollBox,
		title: 'menu.network.polls',
		module: 'MGN,polls',
		children: [
			{
				title: 'menu.network.pollsList',
				to: 'network-polls-list',
			},
			{
				title: 'menu.network.pollsCreate',
				to: 'network-polls-create',
			},
			{
				title: 'menu.network.pollsCategories',
				to: 'network-polls-categories',
			},
		],
	},
	{
		icon: mdiWall,
		title: 'menu.wall',
		module: 'MGN,wall',
		children: [
			{
				title: 'menu.wallBlocks',
				to: 'wall-blocks-list',
			},
			{
				title: 'menu.wallCategories',
				to: 'wall-categories-list',
			},
			{
				title: 'menu.wallMaps',
				to: 'wall-maps-list',
			},
			{
				title: 'menu.wallRewards',
				to: 'wall-rewards-list',
			},
			{
				title: 'menu.wallGrants',
				to: 'wall-grants-list',
			},
		],
	},
	{
		icon: mdiCogs,
		title: 'menu.settings',
		module: 'MGN,settings',
		children: [
			{
				title: 'menu.socialiteProviders',
				to: 'network-socialite-providers-list',
			},
		],
	},

	{
		icon: mdiMessage,
		title: 'menu.messages',
		to: 'mg-platforms-messages',
		module: 'MGN,messages',
	},
	{
		icon: mdiNewspaperVariantMultipleOutline,
		title: 'Newsletter',
		to: 'mg-platforms-newsletters',
		module: 'MGN,newsletter',
	},
	{
		icon: mdiBellOutline,
		title: 'notifications.notifications',
		module: 'MGN,notifications',
		children: [
			{
				title: 'menu.notifications.list',
				to: 'mg-platforms-notifications',
			},
			{
				title: 'menu.notifications.templates',
				to: 'network-notification-templates-list',
			},
			{
				title: 'menu.notifications.suggestions',
				to: 'notification-suggestions',
			},
		],
	},
	{
		icon: mdiPalette,
		title: 'Creative Hub',
		href: 'https://hub.mundogamer.network',
		target: '_blank',
		module: 'MGN,content-engine',
	},
	{
		icon: mdiEmailMultipleOutline,
		title: 'menu.mailHub',
		module: 'MGN,mail-hub',
		children: [
			{
				title: 'menu.mailHubInbox',
				to: 'mail-hub-inbox',
			},
			{
				title: 'menu.mailHubSuggestions',
				to: 'mail-hub-suggestions',
			},
			{
				title: 'menu.mailHubLeads',
				to: 'mail-hub-leads',
			},
			{
				title: 'menu.mailHubSent',
				to: 'mail-hub-sent',
			},
			{
				title: 'menu.mailHubSuppression',
				to: 'mail-hub-suppression',
			},
			{
				title: 'menu.mailHubAccounts',
				to: 'mail-hub-accounts',
			},
			{
				title: 'menu.mailHubChannels',
				to: 'mail-hub-channels',
			},
			{
				title: 'menu.mailHubTemplates',
				to: 'mail-hub-response-templates',
			},
			{
				title: 'menu.mailHubSystemEmails',
				to: 'mail-hub-system-emails',
			},
			{
				title: 'menu.nurtureSequences',
				to: 'mail-hub-nurture-sequences',
			},
			{
				title: 'menu.mailHubSettings',
				to: 'mail-hub-settings',
			},
		],
	},
	{
		icon: mdiLifebuoy,
		title: 'menu.supportTickets',
		to: 'support-tickets-list',
		module: 'MGN,support-tickets',
	},
	{
		icon: mdiAccountSupervisor,
		title: 'Convites para creators',
		to: 'network-creator-outreach',
		module: 'MGN,admin',
	},
	{
		// Grouped on purpose, separate from "Mail Hub" above: these three are
		// all role:MGN,admin (network-wide outbound infra — logs, SES account
		// health, which credential every one of the 10+ services actually
		// sends through). Mail Hub is role:MGN,mail-hub (inbox/leads/support,
		// a wider audience) and is about per-brand IMAP inboxes, a different
		// concern — nesting these under it would hand a control that can
		// redirect the whole network's mail to people who only have Mail Hub
		// access. This group only changes the sidebar; the menu's own module
		// gate plus each route's own meta.module keep the access boundary
		// exactly as it was as three separate items.
		icon: mdiEmailFastOutline,
		title: 'Infraestrutura de E-mail',
		module: 'MGN,admin',
		children: [
			{
				title: 'Email Logs',
				to: 'network-email-logs-list',
			},
			{
				// The logs say which message went out, this says whether the
				// SES account can still send at all.
				icon: mdiHeartPulse,
				title: 'Saúde de Envio (SES)',
				to: 'network-ses-health',
			},
			{
				// Built after an SES account-level shutdown took down every
				// service sharing one credential with no way to swap it
				// without SSHing into each container — this is that switch,
				// from the admin panel.
				icon: mdiSwapHorizontal,
				title: 'Contas de Envio',
				to: 'network-mail-sending-accounts-list',
			},
		],
	},
	{
		icon: mdiChartTimelineVariantShimmer,
		title: 'Conversion Logs',
		to: 'network-conversion-logs-list',
		module: 'MGN,conversion-logs',
	},
	{
		icon: mdiMessageArrowRight,
		title: 'menu.broadcast',
		to: 'network-broadcast',
		module: 'MGN,broadcast',
	},
	{
		icon: mdiLinkVariant,
		title: 'menu.webhookChannels',
		to: 'network-webhook-channels',
		module: 'MGN,webhook-channels',
	},
	{
		icon: mdiRobotOutline,
		title: 'menu.bots',
		to: 'network-bots-list',
		module: 'MGN,bots',
	},
	{
		icon: mdiSourceBranch,
		title: 'menu.deployCenter',
		to: 'deploy-center',
		module: 'MGN,admin',
	},
	{
		// Cross-vertical on purpose: aggregates agency campaign orders,
		// showcase submissions, community review requests, and this queue's
		// own fulfillment_tasks (individually-sold add-ons with no other
		// admin screen) into one list. Same role gate as the endpoint
		// (role:MGN,admin) — see api-main's app/Shared/FulfillmentQueue.
		icon: mdiClipboardCheckOutline,
		title: 'menu.fulfillmentQueue',
		to: 'operations-fulfillment-queue-list',
		module: 'MGN,admin',
	},
]
